import { useState } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";
import "../styling/sidebar.css";
import "../styling/expensepop.css";
import GetUser from "../services/get-user";
import { CircularProgress } from "@material-ui/core";

export default function EUPopup(props) {
  const [name, setName] = useState(props.keydata.name);
  const [amount, setAmount] = useState(props.keydata.amount.split(',').join(''));
  const [expenseID, setexpenseID] = useState(props.keydata._id);
  const [site, setSite] = useState(props.keydata.site);
  const [note, setNote] = useState(props.keydata.note);
  const [usedate, setUseDate] = useState(new Date(props.keydata.realDate));
  const [category, setCategory] = useState(props.keydata.category);
  const [loading, setLoading] = useState(false);
  const user = GetUser();

  function validateForm() {
    return name.length > 0 && amount >= 0 && amount!=null;
  }

  const handleChange = (event) => {
    const { value } = event.target;
    if (value.match(/\./g)) { 
      const [, decimal] = value.split(".");
      if (decimal?.length > 2) {
        return;
      }
    }
    value === "" ? setAmount(null) :setAmount(Number(value));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true)
    try {
      //'http://localhost:8080/income/add_income'
      //return axios.post('http://localhost:8080/expense/update_expense', {
      return axios
        .post("https://sotira-back-test.herokuapp.com/expense/update_expense", {
          userID: user.userID,
          expenseID: expenseID,
          name: name,
          date: usedate,
          amount: amount,
          site: site,
          category: category,
          note: note,
        })
        .then(() => {
          sessionStorage.setItem("option", "expense");
          setLoading(false);
          props.closeUpdateModel(false);
          props.setReloadTableData((prevState)=>!prevState);
          props.setReloadAPI((prevState)=>!prevState);

        });
    } catch (e) {
      setLoading(false)
    }
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Form.Group controlId="name" className="form-group required">
        <Form.Label className="control-label"> Expense Name </Form.Label>
        <Form.Control
          autoFocus
          type="name"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </Form.Group>

      <Form.Group controlId="amount" className="form-group required">
      <Form.Label className="control-label"> Amount $ </Form.Label>
        <div className="d-flex">
        <span className="font-currency mr-2 mt-1">$</span>
          <Form.Control
          autoFocus
          type="number"
          step={0.01}
          value={amount}
          onChange={handleChange}
        />
        </div>
      </Form.Group>

      <Form.Group controlId="date">
        <Form.Label> Date Purchased </Form.Label>
        <DatePicker
          selected={usedate}
          maxDate={new Date()}
          onChange={(date) => setUseDate(date)}
          showTimeSelect
          dateFormate="Pp"
          className="date-picker-input"
        />
      </Form.Group>

      <Form.Group controlId="site">
        <Form.Label className="control-label"> Purchased From </Form.Label>
        <Form.Control
          autoFocus
          type="site"
          value={site}
          onChange={(e) => setSite(e.target.value)}
        />
      </Form.Group>

      <Form.Group controlId="cat">
        <Form.Label> Category </Form.Label>
        <input
          className="form-control"
          type="text"
          defaultValue={category}
          list="categories"
          onChange={(e) => setCategory(e.target.value)}
        />
        <datalist id="categories">
          {props.categories.map((item, key) => (
            <option key={key} value={item} />
          ))}
        </datalist>
      </Form.Group>

      <Form.Group controlId="note">
        <Form.Label> Note </Form.Label>
        <Form.Control
          autoFocus
          type="note"
          value={note}
          onChange={(e) => setNote(e.target.value)}
        />
      </Form.Group>

      <Button block size="sm" type="submit" disabled={!validateForm()}>
      {loading ?
        <><CircularProgress className="file-loader mr-3" />Updating</>
        : 'Save'
      }  
      </Button>
    </Form>
  );
}
